<template>
    <option value="push">push</option>
    <option value="email">email</option>
    <option value="slack">slack</option>
</template>
